/*
  CUSTOM (A/B tests KO.2-KO.4): collection page quick filters, the tidied filter panel and the sort on the small line
  over the filters. Everything listens on the document, so it keeps working when the product list is reloaded.
  - KO.2 quick filters (snippets/collection-quick-filters.liquid): a sheet per filter, from the bottom on a phone and
    a dropdown under its button on a computer. A choice applies at once: the collection is reloaded behind the open
    sheet (list, chips, buttons and "Vis X produkter"), as the filter panel does. "Vis X produkter", × and a click
    outside close the sheet. The chips under the row remove filters the same way, without leaving the page.
  - KO.3 filter panel (snippets/collection-grid-filters-form.liquid): "Flere størrelser" / "Vis alle", the brand
    search, "Vis X produkter" at the bottom (the count comes with every reload of the panel) and "Ryd alle", which
    keeps the panel open
  - KO.4 the sort on the small line passes its choice to the theme's own sort
*/
(function () {
  if (window.mmCollectionFilters) return;
  window.mmCollectionFilters = true;

  var root = document.documentElement;

  // 1394 -> 1.394 (the shop language's way)
  function groupNumber(count) {
    var number = parseInt(count, 10);
    return isNaN(number) ? count : number.toLocaleString(root.lang || undefined);
  }

  function label(template, count) {
    return (template || '').replace('[count]', groupNumber(count));
  }

  /* KO.2 reload of the collection ----------------------------------------------------------------- */

  // the same reload the theme makes for a choice in the filter panel: the section is fetched with the new filters and
  // swapped in, the URL follows, and the theme's scripts run again on the new list
  var renderRequest = 0;
  function renderCollection(params, panelOpen) {
    ['page', 'section_id', 'view'].forEach(function (name) { params.delete(name); });
    var query = params.toString();
    var url = window.location.pathname + (query ? '?' + query : '');
    var content = document.getElementById('CollectionAjaxContent');
    var section = content && content.closest('[data-section-id]');
    if (!section || !window.theme || !theme.sections) {
      window.location.href = url;
      return;
    }

    history.pushState({}, '', url);

    // the filter panel follows the new URL: an open panel is filled again at once (the theme does that when one of
    // its filters changes), a closed one the next time it opens
    var drawerContent = document.getElementById('CollectionGridFiltersFormAjax');
    var panelInput = panelOpen && drawerContent && drawerContent.querySelector('.tag__input');
    if (panelInput) {
      panelInput.dispatchEvent(new Event('change'));
    } else if (drawerContent) {
      drawerContent.innerHTML = '';
    }

    var request = ++renderRequest;
    content.classList.add('is-updating');
    fetch(window.location.pathname + '?section_id=' + section.getAttribute('data-section-id') + (query ? '&' + query : ''))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        if (request !== renderRequest) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionAjaxContent');
        if (!fresh) {
          window.location.href = url;
          return;
        }
        content.innerHTML = fresh.innerHTML;
        content.classList.remove('is-updating');
        theme.sections.reinit('collection-grid');
        if (theme.reinitProductGridItem) theme.reinitProductGridItem();
        document.dispatchEvent(new CustomEvent('collection:reloaded'));
      })
      .catch(function () { window.location.href = url; });
  }

  /* KO.2 quick filters ---------------------------------------------------------------------------- */

  // the sheets and their background live at the end of the page: an open sheet stays as it is while the collection is
  // reloaded behind it. After every reload the closed sheets are swapped for the new ones (their choices follow the
  // URL); the open one only takes the new count on "Vis X produkter".
  var layer = null;
  var openSheet = null;

  function takeSheets() {
    var content = document.getElementById('CollectionAjaxContent') || document.body;
    var fresh = content.querySelectorAll('[data-quick-filter-sheet], [data-quick-filter-scrim]');
    if (!fresh.length) return;
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'quick-filter-layer';
      document.body.appendChild(layer);
    }
    fresh.forEach(function (element) {
      var key = element.getAttribute('data-quick-filter-sheet');
      var current = layer.querySelector(key ? '[data-quick-filter-sheet="' + key + '"]' : '[data-quick-filter-scrim]');
      if (current && openSheet && (current === openSheet || !key)) {
        var go = element.querySelector('[data-quick-filter-apply]');
        var currentGo = current.querySelector('[data-quick-filter-apply]');
        if (go && currentGo) currentGo.textContent = go.textContent;
        element.remove();
      } else if (current) {
        current.replaceWith(element);
      } else {
        layer.appendChild(element);
      }
    });
  }

  takeSheets();
  document.addEventListener('collection:reloaded', takeSheets);

  function sheetParams(sheet) {
    var body = sheet.querySelector('[data-quick-filter-params]');
    return body ? body.getAttribute('data-quick-filter-params').split(',') : [];
  }

  // the URL's filters with this sheet's filter replaced by what is chosen in it (other filters and the sort stay)
  function applySheet(sheet) {
    var params = new URLSearchParams(window.location.search);
    var names = sheetParams(sheet);
    names.forEach(function (name) { params.delete(name); });
    sheet.querySelectorAll('input:checked').forEach(function (input) {
      params.append(input.name, input.value);
      // a price interval also sets its upper end ("1000+" has none)
      if (input.dataset.priceTo) params.append(names[1], input.dataset.priceTo);
    });

    renderCollection(params);
  }

  // on a computer the sheet is a dropdown under its button; on a phone it comes up from the bottom
  var desktop = window.matchMedia('(min-width: 769px)');

  function placeSheet() {
    if (!openSheet) return;
    var opener = document.querySelector('[data-quick-filter-open="' + openSheet.getAttribute('data-quick-filter-sheet') + '"]');
    if (!desktop.matches || !opener) {
      openSheet.style.top = '';
      openSheet.style.left = '';
      return;
    }
    var rect = opener.getBoundingClientRect();
    var left = Math.max(16, Math.min(rect.left, root.clientWidth - openSheet.offsetWidth - 16));
    openSheet.style.top = (rect.bottom + window.scrollY + 8) + 'px';
    openSheet.style.left = (left + window.scrollX) + 'px';
  }

  window.addEventListener('resize', placeSheet);
  document.addEventListener('collection:reloaded', placeSheet);

  function openQuickSheet(key) {
    var sheet = layer && layer.querySelector('[data-quick-filter-sheet="' + key + '"]');
    if (!sheet) return;
    // the same button again closes its dropdown
    if (sheet === openSheet) {
      closeSheet();
      return;
    }
    closeSheet();
    openSheet = sheet;
    placeSheet();
    sheet.classList.add('is-open');
    var scrim = layer.querySelector('[data-quick-filter-scrim]');
    if (scrim) scrim.classList.add('is-open');
    root.classList.add('quick-filter-open');
  }

  function closeSheet() {
    if (!openSheet) return;
    openSheet.classList.remove('is-open');
    var scrim = layer.querySelector('[data-quick-filter-scrim]');
    if (scrim) scrim.classList.remove('is-open');
    root.classList.remove('quick-filter-open');
    openSheet = null;
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest ? e.target : null;
    if (!target) return;

    var opener = target.closest('[data-quick-filter-open]');
    if (opener) {
      openQuickSheet(opener.getAttribute('data-quick-filter-open'));
      return;
    }

    if (target.closest('[data-quick-filter-close]') || target.closest('[data-quick-filter-scrim]') || target.closest('[data-quick-filter-apply]')) {
      closeSheet();
      return;
    }


    var clear = target.closest('[data-quick-filter-clear]');
    if (clear) {
      var clearSheet = clear.closest('[data-quick-filter-sheet]');
      clearSheet.querySelectorAll('input:checked').forEach(function (input) { input.checked = false; });
      clearSheet.querySelectorAll('.quick-filter__option.is-active').forEach(function (option) { option.classList.remove('is-active'); });
      applySheet(clearSheet);
      return;
    }

    // the chips under the row: × removes one, "Ryd alle" all of them
    var chip = target.closest('[data-filter-chip]');
    if (chip) {
      e.preventDefault();
      renderCollection(new URL(chip.href, window.location.origin).searchParams);
    }
  });

  document.addEventListener('change', function (e) {
    var sheet = e.target.closest && e.target.closest('[data-quick-filter-sheet]');
    if (!sheet || (e.target.type !== 'checkbox' && e.target.type !== 'radio')) return;
    // marks follow the inputs, so a newly chosen price interval takes the mark from the one before
    sheet.querySelectorAll('.quick-filter__option').forEach(function (option) {
      var input = option.querySelector('input');
      if (input) option.classList.toggle('is-active', input.checked);
    });
    applySheet(sheet);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });

  // a click anywhere else closes the dropdown; caught on the way down, as the theme stops some clicks (its drawer
  // buttons) before they reach the document
  document.addEventListener('click', function (e) {
    if (!openSheet || !e.target.closest) return;
    if (e.target.closest('[data-quick-filter-sheet]') || e.target.closest('[data-quick-filter-open]')) return;
    closeSheet();
  }, true);

  // and it closes when the theme opens a drawer (the filter panel, the cart, the menu)
  document.addEventListener('drawerOpen', closeSheet);

  /* KO.4 the sort on the small line ---------------------------------------------------------------- */

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-sort-proxy]')) return;
    var themeSort = document.getElementById('SortBy');
    if (themeSort) {
      themeSort.value = e.target.value;
      themeSort.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', e.target.value);
      params.delete('page');
      window.location.search = params.toString();
    }
  });

  /* KO.3 filter panel ------------------------------------------------------------------------------ */

  document.addEventListener('click', function (e) {
    var more = e.target.closest && e.target.closest('[data-filter-more]');
    if (more) {
      e.preventDefault();
      var group = more.closest('.filter-group, .quick-filter-brand');
      if (group) group.classList.add('is-expanded');
      more.hidden = true;
      return;
    }

    var go = e.target.closest && e.target.closest('[data-filter-drawer-go]');
    if (go) {
      var close = document.querySelector('#FilterDrawer .js-drawer-close');
      if (close) close.click();
    }
  });

  // "Ryd alle" in the panel (the chip and the button at the bottom) removes every filter and the panel stays open.
  // Caught before the theme's own chip handling, which leaves filters behind when several kinds are chosen.
  document.addEventListener('click', function (e) {
    var clearAll = e.target.closest && e.target.closest('[data-filter-clear-all], [data-filter-drawer-clear]');
    if (!clearAll) return;
    e.preventDefault();
    e.stopPropagation();
    var current = new URLSearchParams(window.location.search);
    var params = new URLSearchParams();
    ['sort_by', 'q', 'type', 'options[prefix]'].forEach(function (name) {
      if (current.has(name)) params.set(name, current.get(name));
    });
    renderCollection(params, true);
  }, true);

  // caught on the way down and stopped there: the search field sits in the filter form, and the theme reloads the
  // list on every input in that form. The brand quick filter has the same search.
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-filter-search]')) return;
    e.stopPropagation();
    var query = e.target.value.trim().toLowerCase();
    var group = e.target.closest('.filter-group, .quick-filter-brand');
    if (!group) return;
    group.classList.toggle('is-searching', query !== '');
    group.querySelectorAll('.tag-list .tag, .quick-filter__option').forEach(function (tag) {
      var text = (tag.querySelector('.tag__text, .quick-filter__name') || tag).textContent.toLowerCase();
      tag.classList.toggle('is-match', query !== '' && text.indexOf(query) > -1);
    });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-filter-search]')) e.preventDefault();
  });

  // the panel is reloaded after every change; its count goes on "Vis X produkter"
  function syncDrawerCount() {
    var marker = document.querySelector('#CollectionGridFiltersFormAjax [data-filter-count]');
    var go = document.querySelector('[data-filter-drawer-go]');
    if (marker && go) go.textContent = label(go.dataset.label, marker.getAttribute('data-filter-count'));
  }
  var drawerContent = document.getElementById('CollectionGridFiltersFormAjax');
  if (drawerContent && 'MutationObserver' in window) {
    new MutationObserver(syncDrawerCount).observe(drawerContent, { childList: true });
  }
})();
